import { Phone, Mail, MapPin } from 'lucide-react';
import { scrollToId } from '../lib/scroll';

const LINKS = [
  { id: 'supports', label: 'Our Supports' },
  { id: 'why-us', label: 'Why Us' },
  { id: 'areas', label: 'Service Area' },
  { id: 'apply', label: 'Join Us' },
  { id: 'contact', label: 'Contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0B1220] text-white/70">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-16 pb-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-4">
              <img src="/cfa-cover.png" alt="CFA Support Services logo" className="h-14 w-14 rounded-full bg-white object-cover" />
              <div>
                <p className="font-display font-extrabold text-xl text-white tracking-tight">
                  Care For All <span className="text-cyan-300">– Support Services</span>
                </p>
                <p className="font-accent italic text-white/60">Here to serve</p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed max-w-md">
              A registered, audit-approved NDIS provider proudly supporting people with disability across
              Mareeba and all Tablelands regions.
            </p>
            <p className="mt-4 text-[11px] uppercase tracking-[0.28em] font-semibold text-cyan-300/80">
              Empowering · Supporting · Inclusive
            </p>
            <img
              src="/ndis-registered-white.png"
              alt="I love NDIS — Registered NDIS Provider"
              data-testid="footer-ndis-badge"
              className="mt-5 h-10 w-auto"
            />
          </div>

          <div className="md:col-span-3">
            <p className="font-display font-bold text-white text-sm uppercase tracking-[0.2em]">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm hover:text-cyan-300 transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-display font-bold text-white text-sm uppercase tracking-[0.2em]">Contact</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a data-testid="footer-phone" href="tel:0473619278" className="flex items-center gap-2.5 hover:text-cyan-300 transition-colors">
                  <Phone size={15} className="text-cyan-400" /> 0473 619 278
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href="mailto:Careforall.ss@outlook.com"
                  className="flex items-center gap-2.5 hover:text-cyan-300 transition-colors break-all"
                >
                  <Mail size={15} className="text-cyan-400 shrink-0" /> Careforall.ss@outlook.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin size={15} className="text-cyan-400 mt-0.5 shrink-0" />
                2/114 Byrnes St, Mareeba QLD 4880
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p data-testid="footer-copyright">© 2026 Care For All – Support Services. All rights reserved.</p>
          <p>Registered &amp; audit-approved NDIS provider · Mareeba, QLD</p>
        </div>
      </div>
    </footer>
  );
}
